(function() {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function deleteDomainCookie(name) {
    const hostParts = window.location.hostname.split('.');
    let domainStr = "";
    if (hostParts.length >= 2) {
      const baseDomain = hostParts.slice(-2).join('.');
      domainStr = `; domain=.${baseDomain}`;
    }
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domainStr}`;
  }

  // Check if we need to show the cookie consent banner
  if (getCookie("fd_show_cookie_consent") === "true") {
    // Wait for Shopify Customer Privacy API to load
    document.addEventListener("visitorConsentCollected", function() {
      deleteDomainCookie("fd_show_cookie_consent");
    });

    const initPrivacyBanner = function() {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        // Clear flag so it won't re-trigger on next navigate
        deleteDomainCookie("fd_show_cookie_consent");

        // Force-show Shopify Customer Privacy Banner/Modal
        if (typeof window.Shopify.customerPrivacy.showConsentHeader === 'function') {
          window.Shopify.customerPrivacy.showConsentHeader();
        } else if (typeof window.Shopify.customerPrivacy.loadFeatures === 'function') {
          window.Shopify.customerPrivacy.loadFeatures({
            consentBanner: true
          });
        }
      }
    };

    // Initialize when DOM is ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initPrivacyBanner);
    } else {
      initPrivacyBanner();
    }
  }
})();
